<template>
<div>
  <v-dialog v-model="dialogEmployeeRole" persistent max-width="950px">
    <OverlayLoading :loading="loading" />
    <v-card class="pl-5 pr-5  pt-3 pb-3">
      <v-card-title>
        <span class="ra-head-text-bold pa-1" style="color: black;">{{typeAction}}สมาชิก</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              v-model="dataSearchEmployee"
              :items="itemUser"
              item-text="dataShow"
              item-value="employeeId"
              outlined
              dense
              clearable
              class="create-orgchart-type mt-2"
              placeholder="ค้นหา พนักงาน"
              no-data-text="ไม่พบข้อมูล"
              single-line
            >
              <!-- <template v-slot:append>
                <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @change="searchFilterData(), page=1">
              </template> -->
              <!-- <template #selection="{ item }">
                <v-row>
                  <v-col cols="12">
                    <v-chip color="#EFF4FD !important" label small>
                      <span class="filter-chip_department" style="color: #3776E9">{{item.name}}</span>
                    </v-chip>
                  </v-col>
                </v-row>
              </template> -->
            </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-select
              v-model="selectCompanyItem"
              :items="companyItem"
              item-text="name"
              item-value="_id"
              outlined
              dense
              class="mt-2"
              placeholder="ค้นหา บริษัท"
              no-data-text="ไม่พบข้อมูล"
              @change="filterOrgchartData(selectCompanyItem, 'company')"
            >
            </v-select>
          </v-col>
          <v-col cols="4" class="mt-2">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              :nudge-top='-10'
              max-width="328"
              left
              offset-y
              origin='left'
              tile
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="head-search-button"
                  style="width: 96px; height: 38px;"
                  text
                  color="primary"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-filter-variant
                  </v-icon>
                  ตัวกรอง
                </v-btn>
              </template>
              <v-card class="pa-3">
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">สายงาน</span>
                    <v-autocomplete
                      v-model="selectLineOfWorkItem"
                      :items="lineOfWorkItem"
                      item-text="name"
                      item-value="_id"
                      outlined
                      :placeholder="lineOfWorkItem.length === 0 ? 'ไม่มี' : 'เลือกสายงาน'"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      :background-color="lineOfWorkItem.length === 0 ? '#F5F5F5' : '#ffffff'"
                      :disabled="lineOfWorkItem.length === 0"
                      @change="filterOrgchartData(selectLineOfWorkItem, 'lineOfWork')"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">ฝ่ายงาน</span>
                    <v-autocomplete
                      v-model="selectDepartmentItem"
                      :items="departmentItem"
                      item-text="name"
                      item-value="_id"
                      outlined
                      :placeholder="departmentItem.length === 0 ? 'ไม่มี' : 'เลือกฝ่ายงาน'"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      :background-color="departmentItem.length === 0 ? '#F5F5F5' : '#ffffff'"
                      :disabled="departmentItem.length === 0"
                      @change="filterOrgchartData(selectDepartmentItem, 'department')"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">ส่วนงาน</span>
                    <v-autocomplete
                      v-model="selectSectionItem"
                      :items="sectionItem"
                      item-text="name"
                      item-value="_id"
                      outlined
                      :placeholder="sectionItem.length === 0 ? 'ไม่มี' : 'เลือกส่วนงาน'"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      :background-color="sectionItem.length === 0 ? '#F5F5F5' : '#ffffff'"
                      :disabled="sectionItem.length === 0"
                      @change="filterOrgchartData(selectSectionItem, 'section')"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">หน่วยงาน</span>
                    <v-autocomplete
                      v-model="selectAgencyItem"
                      :items="agencyItem"
                      item-text="name"
                      item-value="_id"
                      outlined
                      :placeholder="agencyItem.length === 0 ? 'ไม่มี' : 'เลือกหน่วยงาน'"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      :background-color="agencyItem.length === 0 ? '#F5F5F5' : '#ffffff'"
                      :disabled="agencyItem.length === 0"
                      @change="filterOrgchartData(selectAgencyItem, 'agency')"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">กลุ่มงาน</span>
                    <v-autocomplete
                      v-model="selectGroupItem"
                      :items="groupItem"
                      item-text="name"
                      item-value="_id"
                      outlined
                      :placeholder="groupItem.length === 0 ? 'ไม่มี' : 'เลือกกลุ่มงาน'"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      :background-color="groupItem.length === 0 ? '#F5F5F5' : '#ffffff'"
                      :disabled="groupItem.length === 0"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="d-flex">
                  <v-spacer/>
                  <v-btn
                    class="head-search-button mr-2"
                    outlined
                    color="primary"
                    style="width: 60px;"
                    elevation="0"
                    @click="resetFilterData()"
                  >ล้าง</v-btn>
                  <v-btn
                    class="btn-search-dep ml-2 mr-3"
                    color="primary"
                    style="width: 94px;"
                    dark
                    @click="searchEmployeeOrgchart()"
                  >ค้นหา</v-btn>
                </v-row>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
            class="border-table-employee text-no-wrap table-approve"
            item-key="_id"
            v-model="selected"
            :headers="headers"
            :items="dataSource"
            :loading="loading"
            :search="dataSearchEmployee"
            loader-height=0
            loading-text="Loading... Please wait"
            :footer-props="{
              'items-per-page-options': [15, 30, 50, 100, -1],
              'items-per-page': 15
            }"
            :server-items-length="total || -1"
            @update:items-per-page="changePerPage"
            @update:page="changePage"
            :single-select="singleSelect"
            :show-select="true"
            @input="checkAllowBtn()"
            @toggle-select-all="selectAllToggle"
            disable-sort
          >
            <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-checkbox
                v-show="true"
                v-model="item.selected"
                :value="isSelected"
                hide-details
                class="ma-0"
                style="width: 0px;"
                @change="select($event)"
              />
            </template>
            <template v-slot:[`item.no`]="{ item }">
              {{ (perPage*(page-1)) + dataSource.indexOf(item)+1 }}
            </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- <FullLoading :loading="loadingUsers"></FullLoading> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="ra-button1" color="#1654C6" outlined @click="closeDialog">ยกเลิก</v-btn>
        <v-btn v-if="checkBtnSubmit === false" class="ra-button1" color="grey" depressed disabled>ยืนยัน</v-btn>
        <v-btn v-else class="ra-button1" color="#1654C6" dark @click="confirmAdd()">ยืนยัน</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import { UpdateTitleOrgchart, FullLoading } from '@/components/index'
import
{
  getOrgchartData,
  // fetchAllRequestApproveEmployee,
  getSearchEmployee
  // hostImageUrlv3
} from '@/API/API'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading'
// import { OverlayLoading } from '@/components/index'
const moment = require('moment')

export default {
  name: 'dialog-create-approver',
  components: {
    OverlayLoading
  },
  data () {
    return {
      menu: false,
      isLoading: false,
      loading: false,
      loadingUsers: true,
      dialogEmployeeRole: false,
      selected: [],
      itemUser: [],
      total: -1,
      perPage: 15,
      page: 1,
      singleSelect: false,
      allowBtnApprove: false,
      allowBtnReject: false,
      // approveRole: localStorage.manageapproveRole === 'Admin' ? 'Admin' : 'Leader',
      approveRole: 'Admin',
      searchEmpoyee: '',
      dataSearchEmployee: '',
      typeAction: '',
      selectCompanyItem: '',
      selectLineOfWorkItem: '',
      selectDepartmentItem: '',
      selectSectionItem: '',
      selectAgencyItem: '',
      selectGroupItem: '',
      companyItem: [],
      lineOfWorkItem: [],
      departmentItem: [],
      sectionItem: [],
      agencyItem: [],
      groupItem: [],
      orgChartData: [],
      filterData: {
        approveType: this.mode,
        limit: 15,
        page: 1
      },
      headers: [
        {
          text: 'ลำดับ',
          align: 'left fixed',
          value: 'no',
          width: '70px',
          groupable: false,
          sortable: false,
          class: 'column-fix'
        },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'name' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'ระดับตำแหน่ง', value: 'positionLevel' },
        { text: '', align: 'right', width: '5%', value: 'actions', sortable: false }
      ],
      dataSource: [
      ]
    }
  },
  beforeDestroy () {
    EventBus.$off('openDialogAddAprover')
  },
  mounted () {
    EventBus.$on('openDialogAddAprover', this.openDialogAddAprover)
  },
  computed: {
    checkBtnSubmit () {
      if (this.selected.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.propsEmpId = this.$route.params.id
    // this.getUser()
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.searchEmployeeOrgchart()
    },
    changePage (value) {
      this.page = value
      this.searchEmployeeOrgchart()
    },
    onImgError () {
      this.failed_image = true
    },
    async openDialogAddAprover (value, item, action, index, type) {
      // this.onImgError()
      // console.log('Data Dialog add approver :', value, type, item, action, index)
      this.loading = true
      // this.getUser()
      this.searchEmpoyee = ''
      this.employeeIdDefault = ''
      this.dataSearchEmployee = ''
      this.img = ''
      this.radios = null
      this.action = action
      this.index = index
      this.type = type
      this.dataSearchEmployee = item.employeeId
      await this.getOrgchartData()
      // this.dialogEmployeeRole = value
      if (this.action === 'edit') {
        this.typeAction = 'แก้ไข'
        this.radios = 'ค้นหาจากรหัสพนักงาน'
        await this.searchEmployeeOrgchart(item.employeeId)
        this.searchEmpoyee = item.employeeId
      } else if (this.action === 'add') {
        this.typeAction = 'เพิ่ม'
        // console.log('add')
      }
    },
    closeDialog () {
      // this.clearSearchEmployee()
      this.resetFilterData()
      this.dialogEmployeeRole = false
      this.dataSource = []
    },
    resetFilterData () {
      this.dataSearchEmployee = ''
      this.selectCompanyItem = ''
      this.selectGroupItem = ''
      this.groupItem = []
      this.selectAgencyItem = ''
      this.agencyItem = []
      this.selectSectionItem = ''
      this.sectionItem = []
      this.selectDepartmentItem = ''
      this.departmentItem = []
      this.selectLineOfWorkItem = ''
      this.lineOfWorkItem = []
      this.searchEmployeeOrgchart()
    },
    async filterOrgchartData (id, type) {
      var filterValue = []
      if (type === 'company') {
        this.selectGroupItem = ''
        this.groupItem = []
        this.selectAgencyItem = ''
        this.agencyItem = []
        this.selectSectionItem = ''
        this.sectionItem = []
        this.selectDepartmentItem = ''
        this.departmentItem = []
        this.selectLineOfWorkItem = ''
        this.lineOfWorkItem = []
        filterValue = this.orgChartData.lineOfWork.filter(r => {
          if (r.pid === id) {
            return r
          }
        })
        this.lineOfWorkItem = filterValue
      } else if (type === 'lineOfWork') {
        this.selectGroupItem = ''
        this.groupItem = []
        this.selectSectionItem = ''
        this.sectionItem = []
        this.selectDepartmentItem = ''
        this.departmentItem = []
        filterValue = this.orgChartData.department.filter(r => {
          if (r.pid === id) {
            return r
          }
        })
        this.departmentItem = filterValue
      } else if (type === 'department') {
        this.selectGroupItem = ''
        this.groupItem = []
        this.selectSectionItem = ''
        this.sectiontItem = []
        filterValue = this.orgChartData.section.filter(r => {
          if (r.pid === id) {
            return r
          }
        })
        this.sectionItem = filterValue
      } else if (type === 'section') {
        this.selectGroupItem = ''
        this.groupItem = []
        filterValue = this.orgChartData.agency.filter(r => {
          if (r.pid === id) {
            return r
          }
        })
        this.agencyItem = filterValue
      } else if (type === 'group') {
        filterValue = this.orgChartData.group.filter(r => {
          if (r.pid === id) {
            return r
          }
        })
        this.groupItem = filterValue
      }
    },
    async getOrgchartData () {
      this.loading = true
      // this.loadingUsers = true
      var temp = []
      const obj = {
        accountId: ''
        // accountId: '12277922184'
      }
      try {
        const res = await getOrgchartData(obj, this.tokenUser)
        if (res.success) {
          // temp = res.result
          this.orgChartData = res.result
          this.companyItem = res.result.company
          res.result.employee.map((el, index) => {
            temp.push({
              no: index + 1,
              dataShow: el.employeeId + ' ' + el.name,
              ...el
            })
          })
          this.itemUser = temp
          this.dataSource = temp
          this.loading = false
          this.dialogEmployeeRole = true
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      } finally {
        this.loading = false
        // this.loadingUsers = false
      }
    },
    async searchEmployeeOrgchart (value) {
      this.loading = true
      const temp = []
      const obj = {
        // accountId: '12277922184',
        accountId: '',
        companyId: this.selectCompanyItem,
        lineOfWork: this.selectLineOfWorkItem,
        department: this.selectDepartmentItem,
        section: this.selectSectionItem,
        groupOfWork: this.selectGroupItem,
        agency: this.selectAgencyItem,
        limit: this.perPage,
        page: this.page
      }
      try {
        const res = await getSearchEmployee(obj, this.tokenUser)
        // console.log('🚀 ~ file: ~ res', res)
        if (res.result) {
          res.result.map((el, index) => {
            temp.push({
              no: index + 1,
              dataShow: el.employeeId + ' ' + el.name,
              ...el
            })
          })
          this.total = res.result.count
          this.itemUser = temp
          this.dataSource = res.result
          this.loading = false
        } else {
          // this.dataSearchEmployee = ''
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          this.loading = false
        }
      } catch (error) {
        console.log(error)
        this.dataSearchEmployee = ''
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
      } finally {
        // this.loading = false
        this.loadingUsers = false
        this.loading = false
      }
    },
    confirmAdd () {
      EventBus.$emit('addEmployeeTag', this.selected)
      this.dialogEmployeeRole = false
      this.dataSource = []
      this.selected = []
      this.resetFilterData()
    },
    async computeData (item) {
      await item.map(e => {
        e.updateAt = moment(e.updateAt).format('DD/MM/YYYY HH:mm น.')
      })
    },
    checkAllowBtn () {
      if (this.selected.length > 0) {
        this.allowBtnApprove = true
        this.allowBtnReject = true
      } else {
        this.allowBtnApprove = false
        this.allowBtnReject = false
      }
    },
    select (event) {
      // console.log('event', event)
      this.checkAllowBtn()
    },
    selectAllToggle (props) {
      if (this.selected.length === 0) {
        this.selected = []
        const self = this
        props.items.forEach(item => {
          self.selected.push(item)
        })
      }
    }
  }
}
</script>
<style scoped>
@import '../../../css/ManageEmployee.css';
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
.box-image3 {
  border-width: 1px 1px;
  border-radius: 5px;
  border: 2px solid #e7e7e7;
  height: 40px;

}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.radio-border-click {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
}
.v-input--radio-group.v-input--radio-group--row .v-radio .radio-border-click {
  border-color: red;
}
/* .v-input--radio-group .v-input--radio-group--row .v-radio {
  border-color: red;
} */
/* .radio-border[data-v-c437d5c2] {
  height: 45px;
  border: 2px solid blue;
  border-radius: 5px;
  padding: 15px;
} */
</style>
